<template>
  <md-dialog v-if="showConfirm !== null" :md-active.sync="showConfirm" :md-click-outside-to-close="false" :md-esc-to-close="false" class="confirm-dialog">
    <md-dialog-title class="confirm-title">{{ confirmTitle || trans.title_delete_lang }}</md-dialog-title>

    <md-dialog-content class="confirm-content">
      <p>{{ confirmMessage || trans.confirm_delete_lang }}</p>
    </md-dialog-content>

    <md-dialog-actions class="confirm-actions pb-20">
      <md-button class="md-raised md-primary" @click="$emit('update:showConfirm', false)">{{ trans.Abbrechen}}</md-button>
      <md-button class="md-raised md-primary" @click="onConfirm">{{ trans.confirm}}</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
export default {
  props: {
    showConfirm: Boolean,
    confirmTitle: {
      type: String,
      default: 'Delete Item'
    },
    confirmMessage: {
      type: String,
      default: 'Do you really want to delete this item?'
    },
    trans: {
      type: Object,
      default: () => ({ delete_msg: 'Are you sure?' })
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
      this.$emit('update:showConfirm', false);
    }
  }
}
</script>
<!-- NOT scoped: md-dialog teleports its content to <body>, so scoped styles
     (data-v-* attributes) never reach the dialog markup — that's why it rendered
     with no padding. We key everything on .confirm-dialog so it stays contained
     to this dialog only. -->
<!-- NOT scoped: md-dialog teleports its content to <body>, so scoped styles never
     reach it. The global style.scss forces `.md-dialog .md-dialog-container` to
     width:1136px !important — that's why this dialog rendered huge with content
     jammed to the left. We override the container width here (with !important to
     beat the global rule) and give the inner sections real padding. -->
<style>
.confirm-dialog.md-dialog .md-dialog-container {
  max-width: 440px !important;
  width: 440px !important;
  border-radius: 14px !important;
  overflow: hidden;
}

.confirm-dialog .confirm-title.md-dialog-title {
  text-align: center !important;
  font-weight: 700;
  font-size: 1.25rem;
  color: #2c2c2c;
  padding: 1.75rem 2rem 0.5rem !important;
  margin: 0 !important;
}

.confirm-dialog .confirm-content.md-dialog-content {
  text-align: center;
  font-size: 0.95rem;
  color: #555;
  line-height: 1.5;
  padding: 0.5rem 2rem 1.5rem !important;
}
.confirm-dialog .confirm-content p { margin: 0; }

.confirm-dialog .confirm-actions.md-dialog-actions {
  display: flex !important;
  justify-content: center !important;
  gap: 1rem;
  padding: 0.5rem 2rem 1.75rem !important;
  margin: 0 !important;
}
.confirm-dialog .confirm-actions .md-button {
  margin: 0 !important;
  min-width: 120px;
}
</style>